import { Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { HttpService } from '../../../../shared/services/http/http-client.service';

const API = environment.url_server;

@Injectable({
  providedIn: 'root'
})
export class GestaoBeneficarioService {

  constructor(private http: HttpService) { }

  getBeneficiarios(data: any, successHandle: Function, errorHandle: Function) {
    this.http.doGet('/beneficiario/veb', data, successHandle, errorHandle);
  }

  getBeneficiarioById(id: any, successHandle: Function, errorHandle: Function) {
    this.http.doGet('/beneficiario/veb/'+id, successHandle, errorHandle);
  }

  postBeneficiario(data: any, successHandle: Function, errorHandle: Function) {
    this.http.doPost('/beneficiario/veb', data, successHandle, errorHandle);
  }

  delBeneficiario(id: any, successHandle: Function, errorHandle: Function) {
    this.http.doDelete('/beneficiario/veb/'+id, successHandle, errorHandle);
  }



}
